import React from 'react';

export default function Footer({ children }) {
  return <footer className="app-footer app-footer--custom">{children}</footer>;
}
